if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends DetailsDisclosure {
      constructor() {
        super();

        this.elements = {
          shareButton: this.querySelector('button'),
          shareSummary: this.querySelector('summary'),
          closeButton: this.querySelector('.share-button__close'),
          successMessage: this.querySelector('[id^="ShareMessage"]'),
          urlInput: this.querySelector('input'),
        };
        this.urlToShare = this.elements.urlInput ? this.elements.urlInput.value : document.location.href;

        if (navigator.share) {
          this.mainDetailsToggle.setAttribute('hidden', '');
          this.elements.shareButton.classList.remove('hidden');
          // Evita cliques múltiplos enquanto o share nativo está abrindo
          this._isSharing = false;
          this.elements.shareButton.addEventListener('click', async () => {
            if (this._isSharing) return;
            this._isSharing = true;
            this.elements.shareButton.setAttribute('disabled', 'disabled');
            try {
              await navigator.share({ url: this.urlToShare, title: document.title });
            } catch (e) {
              // usuário pode cancelar; ignorar erro
            } finally {
              this._isSharing = false;
              this.elements.shareButton.removeAttribute('disabled');
            }
          });
        } else {
          this.mainDetailsToggle.addEventListener('toggle', this.toggleDetails.bind(this));
          this.mainDetailsToggle
            .querySelector('.share-button__copy')
            .addEventListener('click', this.copyToClipboard.bind(this));
          this.mainDetailsToggle.querySelector('.share-button__close').addEventListener('click', this.close.bind(this));

          // Debounce de cliques rápidos no summary (evita múltiplas aberturas/fechamentos em sequência)
          if (this.elements.shareSummary) {
            this._lastSummaryClick = 0;
            this.elements.shareSummary.addEventListener('click', (e) => {
              const now = Date.now();
              if (now - this._lastSummaryClick < 350) {
                e.preventDefault();
                e.stopPropagation();
                return false;
              }
              this._lastSummaryClick = now;
            }, true);
          }
        }
      }

      toggleDetails() {
        if (!this.mainDetailsToggle.open) {
          this.elements.successMessage.classList.add('hidden');
          this.elements.successMessage.textContent = '';
          this.elements.closeButton.classList.add('hidden');
          this.elements.shareSummary.focus();
        }
      }

      copyToClipboard() {
        if (this._copyLock) return;
        this._copyLock = true;
        navigator.clipboard.writeText(this.elements.urlInput.value)
          .then(() => {
            this.elements.successMessage.classList.remove('hidden');
            this.elements.successMessage.textContent = window.accessibilityStrings.shareSuccess;
            this.elements.closeButton.classList.remove('hidden');
            this.elements.closeButton.focus();
          })
          .catch(() => {})
          .finally(() => {
            setTimeout(() => (this._copyLock = false), 400);
          });
      }

      updateUrl(url) {
        this.urlToShare = url;
        this.elements.urlInput.value = url;
      }
    }
  );
}
